'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Search = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactHelmet = require('react-helmet');

var _reactHelmet2 = _interopRequireDefault(_reactHelmet);

var _reactRedux = require('react-redux');

var _nuiIntl = require('@concur/nui-intl');

var _listingsModule = require('../listings/listingsModule');

var ListingsActions = _interopRequireWildcard(_listingsModule);

var _Header = require('../shared/Header');

var _Header2 = _interopRequireDefault(_Header);

var _CommonSections = require('../shared/CommonSections');

var _CommonSections2 = _interopRequireDefault(_CommonSections);

var _utils = require('../utils');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Search = exports.Search = function (_Component) {
  _inherits(Search, _Component);

  function Search(props) {
    _classCallCheck(this, Search);

    var _this = _possibleConstructorReturn(this, (Search.__proto__ || Object.getPrototypeOf(Search)).call(this, props));

    _this.dispatchSearch = _this.dispatchSearch.bind(_this);
    return _this;
  }

  _createClass(Search, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          params = _props.params,
          setAndFilter = _props.setAndFilter;


      if (this.context.isPublic) {
        if ((0, _utils.canUseDOM)() && window.utag) {
          (0, _utils.sendPublicView)();
        }
      }

      setAndFilter((0, _utils.escapeHTML)(params.term));
    }
  }, {
    key: 'dispatchSearch',
    value: function dispatchSearch(val) {
      this.props.dispatch(ListingsActions.fetchListingsIfNeeded());
      this.props.dispatch(ListingsActions.setAndFilter(val));
    }
  }, {
    key: 'render',
    value: function render() {
      var term = this.props.params.term;

      var sanitizedTerm = (0, _utils.escapeHTML)(term);
      return _react2.default.createElement(
        'div',
        { className: 'row' },
        _react2.default.createElement(
          'div',
          { className: 'col-xs-12' },
          _react2.default.createElement(_reactHelmet2.default, { title: this.context.getTitle('Search: ' + sanitizedTerm) }),
          _react2.default.createElement(_Header2.default, null),
          _react2.default.createElement(
            'h2',
            { id: 'ac-search-results-for', style: { textTransform: 'none' } },
            _react2.default.createElement(_nuiIntl.FormattedMessage, { id: 'ShowingResultsFor', values: { term: sanitizedTerm } })
          ),
          _react2.default.createElement('hr', null),
          _react2.default.createElement(_CommonSections2.default, null)
        )
      );
    }
  }]);

  return Search;
}(_react.Component);

Search.propTypes = {
  dispatch: _propTypes2.default.func,
  params: _propTypes2.default.shape({
    term: _propTypes2.default.string
  }),
  fetchListingsIfNeeded: _propTypes2.default.func,
  setAndFilter: _propTypes2.default.func
};

Search.contextTypes = {
  isPublic: _propTypes2.default.bool,
  getTitle: _propTypes2.default.func
};

function mapStateToProps(state) {
  return {
    listings: state.listings,
    userPrefs: state.userPrefs
  };
}

var mapDispatchToProps = {
  fetchListingsIfNeeded: ListingsActions.fetchListingsIfNeeded,
  setAndFilter: ListingsActions.setAndFilter
};

exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Search);


//////////////////
// WEBPACK FOOTER
// ./lib/search/SearchContainer.js
// module id = 597
// module chunks = 0